import type { IconData } from '@stacksjs/iconify-core'

export const shareLinkFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M38.683 10.658a3 3 0 0 1-1.341 4.025L18.708 24l18.634 9.316a3 3 0 0 1-2.684 5.367l-24-12a3 3 0 0 1 0-5.367l24-12a3 3 0 0 1 4.025 1.342\" clip-rule=\"evenodd\"/><path fill=\"#8fbffa\" d=\"M11 14.5a9.5 9.5 0 1 0 0 19a9.5 9.5 0 0 0 0-19m26 13a9.5 9.5 0 1 0 0 19a9.5 9.5 0 0 0 0-19m0-26a9.5 9.5 0 1 0 0 19a9.5 9.5 0 0 0 0-19\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shareLinkFlat
